import React, { useContext, useEffect, useState } from 'react'
import { observer } from 'mobx-react-lite'
import { IOrgStageCoordsGetterOutput } from '../functions/getOrgStages-1'
import D3Circle from '../../D3Components/D3Circle';
import RootStoreContext from '../../../storage/RootStore';
import { constants } from '../../../Constants'
import { getIDs } from '../functions/getID';
import D3Line from '../../D3Components/D3Line';

/// Icons
import { FaBuilding } from 'react-icons/fa'

interface Props extends IOrgStageCoordsGetterOutput { }

const { CIRCLE, BLOCK } = constants




export const CircleExtended = (props: {
    type: 'organizations' | 'problems' | 'documents' | 'additional',
    coords: { x: number, y: number },
    orgStageID: string
}) => {

    const { coords, orgStageID, type } = props

    const { orgID, stageID } = getIDs(orgStageID)


    const color = type === 'problems' ? 'darkred' :
        type === 'documents' ? '#3d85c6' :
            type === 'organizations' ? '#6aa84f' :
                type === 'additional' ? '#674ea7' : 'black'


    const dotProps = {
        r: CIRCLE.RADIUS_SELECTED,
        fill: color,
        fillOpacity: 0.4,
        strokeWidth: 3,
        stroke: color,
        cursor: 'pointer' as 'pointer',
        dataOrg: orgID,
        dataStage: stageID,
        dataID: orgStageID
    }

    return (<g>
        <D3Circle {...coords} {...dotProps} onClick={() => null}>

        </D3Circle>
        <FaBuilding cursor={'pointer'} x={coords.x - 7} y={coords.y - 7} size={14} fill={color} />
        <title>{type}</title>
    </g>)
}




export const NodeCirclesExtended: React.FC<Props> = observer(({
    connectionDotsCoords, orgStagesCoords
}) => {

    const { selection } = useContext(RootStoreContext)

    const orgStageID = selection.orgStage

    if (!orgStageID) return null

    const dot = orgStagesCoords[orgStageID];

    const top = -BLOCK.HEIGHT / 2;
    const left = -BLOCK.WIDTH / 4;
    const right = BLOCK.WIDTH / 4
    const bottom = BLOCK.HEIGHT / 2

    // const coords = {
    //     topleft: { x: dot.x + left, y: dot.y + top },
    //     topright: { x: dot.x + right, y: dot.y + top },
    //     bottomleft: { x: dot.x + left, y: dot.y + bottom },
    //     bottomright: { x: dot.x + right, y: dot.y + bottom },
    // }


    // if (selection.orgStage && orgStagesCoords[orgStageID] && orgStagesCoords[orgStageID].node) {
    //     return (<g id='circles-extended'>
    //         <CircleExtended type={'problems'} coords={coords.topleft} orgStageID={orgStageID} />
    //         <CircleExtended type={'documents'} coords={coords.topright} orgStageID={orgStageID} />
    //         <CircleExtended type={'organizations'} coords={coords.bottomleft} orgStageID={orgStageID} />
    //         <CircleExtended type={'additional'} coords={coords.bottomright} orgStageID={orgStageID} />
    //     </g>)
    // }

    return null
})
